// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Ns0Sj0nEGMQ7un {
  display: block;
  margin-bottom: var(--ds-space-050, 4px);
  overflow: hidden;
  overflow-wrap: break-word;
  white-space: normal;
}
.Ns0Sj0nEGMQ7un,
.Ns0Sj0nEGMQ7un:hover,
.Ns0Sj0nEGMQ7un:active {
  color: var(--ds-text, #172b4d);
  text-decoration: none;
}
.Ns0Sj0nEGMQ7un:focus {
  outline: none;
}
.bt8Kep_tlzDiOi {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
`, ""]);
// Exports
export var name = `Ns0Sj0nEGMQ7un`;
export var truncate = `bt8Kep_tlzDiOi`;
export default ___CSS_LOADER_EXPORT___;
